var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherTransation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 633387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0201 2.14865C9.82227 2.14865 9.66195 2.30897 9.66195 2.50676V5.37161C9.66195 5.96495 9.18096 6.44595 8.58763 6.44595C7.9943 6.44595 7.51331 5.96495 7.51331 5.37161V2.50676C7.51331 1.12233 8.63559 0 10.0201 0H28.6417C30.0261 0 31.1484 1.12233 31.1484 2.50676V15.3986C31.1484 16.7831 30.0261 17.9054 28.6417 17.9054H27.2093C26.6159 17.9054 26.1349 17.4244 26.1349 16.8311C26.1349 16.2378 26.6159 15.7568 27.2093 15.7568H28.6417C28.8395 15.7568 28.9998 15.5965 28.9998 15.3986V2.50676C28.9998 2.30897 28.8395 2.14865 28.6417 2.14865H10.0201Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85783 10.7433C2.66005 10.7433 2.49972 10.9035 2.49972 11.1014V23.9933C2.49972 24.1911 2.66005 24.3514 2.85783 24.3514H21.4795C21.6773 24.3514 21.8376 24.1911 21.8376 23.9933V11.1014C21.8376 10.9035 21.6773 10.7433 21.4795 10.7433H2.85783ZM0.351074 11.1014C0.351074 9.71692 1.47339 8.5946 2.85783 8.5946H21.4795C22.8639 8.5946 23.9862 9.71692 23.9862 11.1014V23.9933C23.9862 25.3777 22.8639 26.5 21.4795 26.5H2.85783C1.47339 26.5 0.351074 25.3777 0.351074 23.9933V11.1014Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351074 16.1149C0.351074 15.5215 0.832071 15.0405 1.4254 15.0405H22.9119C23.5052 15.0405 23.9862 15.5215 23.9862 16.1149C23.9862 16.7082 23.5052 17.1892 22.9119 17.1892H1.4254C0.832071 17.1892 0.351074 16.7082 0.351074 16.1149Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.912 11.4595C23.5053 11.4595 23.9863 11.9405 23.9863 12.5338V21.1284C23.9863 21.7217 23.5053 22.2027 22.912 22.2027C22.3187 22.2027 21.8376 21.7217 21.8376 21.1284V12.5338C21.8376 11.9405 22.3187 11.4595 22.912 11.4595Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4254 11.4595C2.01873 11.4595 2.49972 11.9405 2.49972 12.5338V21.1284C2.49972 21.7217 2.01873 22.2027 1.4254 22.2027C0.832071 22.2027 0.351074 21.7217 0.351074 21.1284V12.5338C0.351074 11.9405 0.832071 11.4595 1.4254 11.4595Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36462 20.4122C5.36462 19.8188 5.84562 19.3378 6.43895 19.3378H12.1687C12.762 19.3378 13.243 19.8188 13.243 20.4122C13.243 21.0055 12.762 21.4865 12.1687 21.4865H6.43895C5.84562 21.4865 5.36462 21.0055 5.36462 20.4122Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3916 20.4122C15.3916 19.8188 15.8726 19.3378 16.4659 19.3378H17.8984C18.4917 19.3378 18.9727 19.8188 18.9727 20.4122C18.9727 21.0055 18.4917 21.4865 17.8984 21.4865H16.4659C15.8726 21.4865 15.3916 21.0055 15.3916 20.4122Z",
    fill: "#0066FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTransation);
export default __webpack_public_path__ + "static/media/other_transation.082aa7017057079ad0ff7ccd94ffe2a7.svg";
export { ForwardRef as ReactComponent };